import { ILocation, LocationType } from "./locationTypes";

/** A Graph-shaped site as /sites returns it, plus the hub decoration getLocationSubSites adds. */
export interface IGraphSiteLike {
    id: string;
    displayName: string;
    description?: string;
    webUrl: string;
    createdDateTime?: string | Date;
    lastModifiedDateTime?: string | Date;
    isHub?: boolean;
    hubId?: string;
    parentHubId?: string;
}

const formatDate = (value: string | Date | undefined): { text: string; value: number } => {
    const date: Date | undefined = value ? new Date(value) : undefined;
    const valid: boolean = date !== undefined && !isNaN(date.valueOf());
    return {
        text: valid ? date.toLocaleDateString(navigator.languages) : "-",
        value: valid ? date.valueOf() : 0,
    };
};

/** The one mapping from a Graph-shaped site to a locations-list row. Hub-associated sites,
 * subsites and client-group members all go through it, so they render, navigate and sort
 * identically. */
export const mapGraphSiteToLocation = (site: IGraphSiteLike, index: number): ILocation => {
    const created = formatDate(site.createdDateTime);
    const modified = formatDate(site.lastModifiedDateTime);
    return {
        key: `s${index}`,
        id: site.id,
        displayName: site.displayName,
        description: site.description,
        createdDateTime: created.text,
        createdDateTimeValue: created.value,
        lastModifiedDateTime: modified.text,
        lastModifiedDateTimeValue: modified.value,
        webUrl: site.webUrl,
        type: site.isHub ? LocationType.HubSite : LocationType.Site,
        isHub: site.isHub,
        hubId: site.hubId,
        parentHubId: site.parentHubId
    };
};

/** A web beneath the current site (`/sites/{id}/sites`): the only rows that are subsites. */
export const mapGraphSubsiteToLocation = (site: IGraphSiteLike, index: number): ILocation =>
    ({ ...mapGraphSiteToLocation(site, index), isSubsite: true });
